import IntroductionJackboxContainer from './introductionjackbox'

export default IntroductionJackboxContainer